import actions from './actions';
import type { AuthState } from './models';

const initialState: AuthState = {
  refreshTokenStatus: 'idle',
  signInStatus: 'idle',
  logoutStatus: 'idle',
  logoutError: null,
  signInError: null,
};

const reducer = (state = initialState, action: any): AuthState => {
  switch (action.type) {
    case actions.SIGN_IN.started().type:
      return {
        ...state,
        signInStatus: 'loading',
      };
    case actions.SIGN_IN.success().type:
      return {
        ...state,
        signInStatus: 'success',
      };
    case actions.SIGN_IN.error().type:
      return {
        ...state,
        signInStatus: 'error',
        signInError: action.payload,
      };
    case actions.LOGOUT.started().type:
      return {
        ...state,
        signInStatus: 'idle',
        logoutStatus: 'loading',
      };
    case actions.LOGOUT.success().type:
      return {
        ...state,
        logoutStatus: 'success',
      };
    case actions.LOGOUT.error().type:
      return {
        ...state,
        logoutStatus: 'error',
        logoutError: action.payload,
      };
    case actions.REFRESH_ACCESS_TOKEN.started().type:
      return {
        ...state,
        refreshTokenStatus: 'loading',
      };
    case actions.REFRESH_ACCESS_TOKEN.success().type:
      return {
        ...state,
        refreshTokenStatus: 'success',
      };
    case actions.REFRESH_ACCESS_TOKEN.error().type:
      return {
        ...state,
        refreshTokenStatus: 'error',
      };
    default:
      return state;
  }
};

export default reducer;
